import { render } from "./Confirm.vue?vue&type=template&id=45681ccb&scoped=true"
import script from "./Confirm.vue?vue&type=script&lang=js"
export * from "./Confirm.vue?vue&type=script&lang=js"

import "./Confirm.vue?vue&type=style&index=0&id=45681ccb&scoped=true&lang=css"

import exportComponent from "/home/ubuntu/www/releases/20260911022515/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45681ccb"]])

export default __exports__